import React, { useState, useEffect } from 'react';
import PeopleData from '../../services/people-service';
import './people-management.css'


export function PeopleManagement({ accessToken }) {
  const [data, setData] = useState(null);
  const [currentAccessToken, setCurrentAccessToken] = useState(null);

  const deletePerson = async (event) => {
    const id = event.target.value;
    console.log("ID: " + id);
    try {
      await PeopleData.deletePerson(id, currentAccessToken);
      const newData = await PeopleData.getData(currentAccessToken);
      setData(newData);
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (accessToken) {
        const fetchedData = await PeopleData.getData(accessToken);
        setData(fetchedData);
        setCurrentAccessToken(accessToken);
      }
    };
    fetchData();
  }, [accessToken]);

  const filterUsers = (user, data) => {
    console.log("Filtering for user: " + user);
    return data.filter(function(data) { 
      return data.personID === user;
    });
  };

  const [activeTab, setActiveTab] = useState(0);
  const [settings, setSettings] = useState({
    notifications: true,
    twoFactor: false,
    marketing: true
  });

  const toggleSetting = (setting) => {
    setSettings(prev => ({
      ...prev,
      [setting]: !prev[setting]
    }));
  };

  const tabs = [
    { id: 0, label: 'Dashboard' },
    { id: 1, label: 'Analytics' },
    { id: 2, label: 'Settings' }
  ];

  if (!currentAccessToken) {
    return <div>Loading...</div>;
  }

  const renderContent = () => {
    switch(activeTab) {
      case 0:
        return (
          <div className="content-section">
            <h3>Dashboard Overview</h3>
            <p>Welcome to your dashboard! Here's a quick overview of your key metrics.</p>
            
            <div className="stats-grid">
              <div className="stat-box">
                <div className="stat-number">1,247</div>
                <div className="stat-label">Total Users</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">$12,840</div>
                <div className="stat-label">Revenue</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">94.2%</div>
                <div className="stat-label">Satisfaction</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">2.4%</div>
                <div className="stat-label">Conversion</div>
              </div>
            </div>
            
            <p>Your account is performing well this month with steady growth across all metrics.</p>
          </div>
        );
      
      case 1:
        return (
          <div className="content-section">
            <h3>Analytics Report</h3>
            <p>Detailed analytics and performance metrics for your application.</p>
            
            <div className="stats-grid">
              <div className="stat-box">
                <div className="stat-number">98.7%</div>
                <div className="stat-label">Uptime</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">1.2s</div>
                <div className="stat-label">Load Time</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">847</div>
                <div className="stat-label">Daily Visits</div>
              </div>
            </div>
            
            <p>Traffic has increased by 23% compared to last month. Most visitors are coming from organic search and direct traffic.</p>
            <p>Page load times have improved significantly after recent optimizations.</p>
          </div>
        );
      
      case 2:
        return (
          <div className="content-section">
            <h3>Account Settings</h3>
            <p>Manage your account preferences and security settings.</p>
            
            <div style={{ marginBottom: '30px' }}>
              <h4 style={{ marginBottom: '15px' }}>Notifications</h4>
              
              <div className="setting-item">
                <div>
                  <strong>Email Notifications</strong>
                  <div style={{ fontSize: '14px', color: '#666' }}>Receive updates via email</div>
                </div>
                <div 
                  className={`toggle-switch ${settings.notifications ? 'on' : ''}`}
                  onClick={() => toggleSetting('notifications')}
                >
                  <div className="toggle-handle"></div>
                </div>
              </div>
              
              <div className="setting-item">
                <div>
                  <strong>Two-Factor Auth</strong>
                  <div style={{ fontSize: '14px', color: '#666' }}>Extra security layer</div>
                </div>
                <div 
                  className={`toggle-switch ${settings.twoFactor ? 'on' : ''}`}
                  onClick={() => toggleSetting('twoFactor')}
                >
                  <div className="toggle-handle"></div>
                </div>
              </div>
              
              <div className="setting-item">
                <div>
                  <strong>Marketing Emails</strong>
                  <div style={{ fontSize: '14px', color: '#666' }}>Product updates and offers</div>
                </div>
                <div 
                  className={`toggle-switch ${settings.marketing ? 'on' : ''}`}
                  onClick={() => toggleSetting('marketing')}
                >
                  <div className="toggle-handle"></div>
                </div>
              </div>
            </div>
            
            <h4 style={{ marginBottom: '15px' }}>Preferences</h4>
            <div className="form-group">
              <label>Theme</label>
              <select>
                <option>Light</option>
                <option>Dark</option>
                <option>Auto</option>
              </select>
            </div>
            
            <div className="form-group">
              <label>Language</label>
              <select>
                <option>English</option>
                <option>Spanish</option>
                <option>French</option>
              </select>
            </div>
            
            <div className="form-group">
              <label>Email</label>
              <input type="email" placeholder="your@email.com" />
            </div>
          </div>
        );
      
      default:
        return <div>Content not found</div>;
    }
  };

  return (
    <>
      <div className="simple-tabs">
        <div className="tab-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        
        <div className="tab-content">
          {renderContent()}
        </div>
      </div>
    </>
  );
}